module.exports = ":host {\n  flex-grow: 1;\n}\n"